import { UtilitiesService } from './services';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextbookDrawerModule } from '@textbook-drawer';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxPaginationModule } from 'ngx-pagination';
import { TextbookMobileDetectProvider } from '../../../external/providers/mobile-detect-provider.service';
import { DocumentsPaginatorComponent } from './components/documents-paginator/documents-paginator.component';
import { DrawerBackButtonComponent } from './components/drawer/drawer-back-button/drawer-back-button.component';
import { DrawerComponent } from './components/drawer/drawer.component';
import { GroupPaginatorComponent } from './components/group-paginator/group-paginator.component';
import { ImageWrapperComponent } from './components/image-wrapper/image-wrapper.component';
import { MediaPlayerComponent } from './components/media-player/media-player.component';
import { ModalComponent } from './components/modal/modal.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ImageZoomComponent } from './components/zoom-image/image.component';
import { DragHandleDirective } from './directives/drag/drag-handle.directive';
import { DraggableDirective } from './directives/drag/draggable.directive';
import { FocusDirective } from './directives/focus.directive';
import { ProportionalImageDirective } from './directives/proportional-image.directive';
import { ActionNotesService } from './services/action-notes.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TextbookActionBase } from './textbook-action-base.model';
import { CommonUtilityModule } from '../../common-utility/common-utility.module';
import { DrawingUtilityModule } from '../../drawing-utility/drawing-utility.module';
import { ZoomDirectiveModule } from '../../../external/zoom-directive/zoom-directive.module';

@NgModule({
  declarations: [
    ModalComponent,
    DraggableDirective,
    DragHandleDirective,
    ProportionalImageDirective,
    FocusDirective,
    DrawerComponent,
    DrawerBackButtonComponent,
    ImageZoomComponent,
    PaginatorComponent,
    MediaPlayerComponent,
    DocumentsPaginatorComponent,
    GroupPaginatorComponent,
    SpinnerComponent,
    ImageWrapperComponent,
    TextbookActionBase,
  ],
  exports: [
    ModalComponent,
    DrawerComponent,
    ProportionalImageDirective,
    ImageZoomComponent,
    PaginatorComponent,
    MediaPlayerComponent,
    DocumentsPaginatorComponent,
    NgxPaginationModule,
    SweetAlert2Module,
    ImageWrapperComponent,
    SpinnerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TextbookDrawerModule,
    NgxPaginationModule,
    DragDropModule,
    SweetAlert2Module.forRoot(),
    CommonUtilityModule,
    DrawingUtilityModule,
    ZoomDirectiveModule,
  ],
  providers: [TextbookMobileDetectProvider, UtilitiesService, ActionNotesService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TextbookActionsBaseModule {}
